<template>
	<div class="purchase-subscription-banner" :class="{collapsed, offline}">
		<AppClickableIcon
			v-if="dismissable"
			class="close-banner-btn"
			:auto-set-active="false"
			icon-name="iconX"
			@click-icon="$emit('click-collapse')"
		/>
		<p>{{text}}</p>
		<AppButton small inverted :text="buttonText" @click="$emit('click-button')" :loading="loading" :disabled="disabledCta" v-if="!offline" />
	</div>
</template>

<script>
import AppClickableIcon from "@/shared/components/AppClickableIcon.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		return {getString: languageStore.getString, userStore};
	},
	emits: ["click-button", "click-collapse"],
	name: "TopBanner",
	components: {AppButton, AppClickableIcon},
	props: {
		text: {
			type: String,
			default: "",
		},
		buttonText: {
			type: String,
			default: "",
		},
		dismissable: {
			type: Boolean,
			default: false,
		},
		disabledCta: {
			type: Boolean,
			default: false,
		},
		collapsed: {
			type: Boolean,
			default: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		offline: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style scoped lang="scss">
.purchase-subscription-banner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 10px;
	height: 40px;
	opacity: 1;
	background: linear-gradient(192deg, rgba(7,82,163,1) 10%, rgb(47 236 191) 80%);
	background-size: 120% 120%;
	box-shadow: inset 0 -1px 10px rgb(7 82 163 / 25%);
	transition: height .3s ease, opacity .3s ease;
	animation: animated-gradient 5s ease infinite;

	&.collapsed {
		overflow: hidden;
		height: 0;
		opacity: 0;
	}

	.close-banner-btn {
		width: 12px;
		height: 12px;
		margin-bottom: 6px;
	}

	p {
		@include truncateString();
		color: $primary;
		width: calc(100% - 115px);
		font-weight: 500;
		margin-right: auto;
		padding-left: 10px;
	}
	:deep(svg) path.stroke {
		stroke: rgba(7, 82, 163, 0.35);
	}
	.base-button {
		padding: 6px 7px;
		border-radius: 11px;
	}

	&.offline {
		background: $danger;
		box-shadow: inset 0 -1px 10px rgb(163 7 7 / 25%);

		p {
			color: var(--color-bg);
		}
	}
}
@keyframes animated-gradient {
	0%{background-position: 0 50%}
	50%{background-position: 100% 50%}
	100%{background-position: 0 50%}
}
</style>